<template>
  <v-app :style="{backgroundImage: 'url('+bgImgUrlCmplt+')'}" dark 
    :class="[isMobile ? 'scroll-snap-type' : '']" > 
    <!-- :class="[isMobile ? 'scroll-snap-type' : '']"    class="scroll-snap-type" -->
    <!-- <Drawer :contacts="drawerItems" v-model="drawer" /> -->
    <v-app-bar app fixed dense>
      <!-- app dense extended prominent clipped-right collapse class="d-flex flex-wrap" -->
      <!-- <template v-slot:extension>
            <v-spacer></v-spacer>
        <v-btn v-if="$route.path == '/ax-corps'" outlined color="cyan accent-4" href="https://docs.google.com/document/d/18QfFuoblh1TA4lzFqBSTfP-CygLwjDOp-8CK2O3XK4M/edit?usp=sharing" target='_blank'>
          Руководство AX пилота
        </v-btn>
        <v-btn v-else-if="$route.path == '/fraction-eg-union'" outlined color="cyan accent-4" to="/euryale-chronicles">
          Хроники Эвриалы
        </v-btn>
        <v-btn v-else-if="$route.path == '/hall-of-glory-egp'" outlined color="cyan accent-4" to="/catalogue-awards">
          Каталог наград
        </v-btn>
        <v-btn v-else outlined color="cyan accent-4" to="/thunderer">
          Журнал Громовержец
        </v-btn>
      </template> -->
      <v-toolbar-title>
        <v-btn to="/" :style="{ fontFamily: 'ElementalEnd' }" class="text-none">
            <v-img width='25px' :src="require('@/assets/animate-logo-white.svg')" />
            EG pilots
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-items ></v-toolbar-items> -->
      <!-- Drawer toggle -->
        <!-- <v-btn fab small @click.stop="drawer = !drawer">
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-btn> -->
        <!--  -->
    </v-app-bar>
    <v-content>
      <v-container fluid ma-0 pa-0>
        <Logo />
        <transition name="fade" mode="out-in">

          <router-view :isMobile="isMobile" />

        </transition>
      </v-container>
    </v-content>
    <GoToTop :isMobile="isMobile" />
    <!--  -->
    <v-footer :class="[(isMobile && this.$route.path == '/') ? 'scroll-snap-type-item' : '']" >
      <v-container>
        <v-row justify="space-around">
            <!-- col-1 -->
            <v-col cols="12" md="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-btn text
                    v-for="contact in contacts" 
                    :key="contact.title" 
                    color="#ff7100"
                    class="footer-link" 
                    target='_blank' :href="contact.link">
                        <v-icon left v-if="contact.icon">{{contact.icon}}</v-icon>
                        {{ contact.title }}
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
            </v-col>
            <!-- col-2 -->
            <v-col cols="12" md="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-btn text 
                    v-for="source in sources" 
                    :key="source.title" 
                    class="footer-link" 
                    target='_blank' :href="source.link">
                        <v-icon left v-if="source.icon">{{source.icon}}</v-icon>
                        <img class="mr-1" width='40px' v-if="source.src" :src="source.src" />
                        {{ source.title }}
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
            </v-col>
            <!-- col-3 -->
            <v-col cols="12" md="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-btn text 
                    v-for="link in links" 
                    :key="link.title" 
                    color="cyan accent-4" 
                    class="footer-link" :to="link.link">
                        <v-icon left v-if="link.icon">{{link.icon}}</v-icon>
                        <img class="mr-1" width='25px' v-if="link.src" :src="link.src" />
                        {{ link.title }}
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
            </v-col>

        </v-row>
        <!--  -->
        <v-row>
          <v-col class="text-center" cols="12">
            <p class="my-0 mx-auto text-md-center">&#169; EG Pilots, {{ new Date().getFullYear() }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>

  </v-app>
</template>
<script>
export default {
  name: 'App',
  components: {
    // Drawer: () => import('@/components/Drawer'),
    Logo: () => import('@/components/Logo'),
    GoToTop: () => import('@/components/GoToTop')
  },
  data() {
    return {
      isMobile: false,
      // Переключатель сайдбара с сыылками
      // drawer: false,
      // ссылки для фона
      bgImgUrlCmplt: '/img/background/bg-1.jpg',
      bgImgUrl: '/img/background/',
      bgImgArr: [
        'bg-1.jpg',
        'bg-2.jpg',
        'bg-3.jpg',
        'bg-4.jpg',
        'bg-5.jpg',
      ],
      // Ссылки для сайдбара
      contacts: [{
          icon: 'mdi-discord',
          title: 'Чат EG Pilots',
          link: process.env.VUE_APP_LINK_EGP
        },
        // {
        //   title: 'Вступить в EG Pilots',
        //   link: 'http://www.elite-games.ru/conference/viewtopic.php?p=3430819'
        // },
        {
          icon: 'mdi-vk',
          title: 'EG Pilots Вконтакте',
          link: process.env.VUE_APP_LINK_VK
        },
        {
          icon: 'mdi-discord',
          title: 'Дипломатический канал', // EG Pilots (сильно длинное название)
          link: process.env.VUE_APP_LINK_DIPLOMAT
        }],

        sources: [{
          icon: 'mdi-star-four-points-outline',
          title: 'Elite-Games.ru',
          link: 'http://www.elite-games.ru'
        },
        {
          // icon: 'mdi-web',
          src: "/img/inara.svg",
          title: 'EG Pilots на Inara.cz',
          link: 'http://inara.cz/wing/926'
        },
        {
          icon: 'mdi-folder-google-drive',
          title: 'Руководство AX пилота',
          link: process.env.VUE_APP_LINK_AX_MAN
        }],

        links: [{
            // icon: 'mdi-share-variant',
            src: "/img/path-cyan.svg",
            title: 'Хроники Эвриалы',
            link: '/euryale-chronicles'
        },
        {
            // icon: 'mdi-share-variant',
            src: "/img/path-cyan.svg",
            title: 'Каталог наград',
            link: '/catalogue-awards'
        },
        {
            // icon: 'mdi-share-variant',
            src: "/img/path-cyan.svg",
            title: 'Журнал Громовержец',
            link: '/thunderer'
        }]
    };
  },
  /*computed: {
    drawerItems: function() { 
        return this.contacts.concat(this.sources).concat(this.links);
    }
  },*/
  watch: {
    $route( /*to, from*/ ) {
      // обрабатываем изменение параметров маршрута...
      let i = Math.floor(Math.random() * this.bgImgArr.length)
      this.bgImgUrlCmplt = this.bgImgUrl + this.bgImgArr[i];
    },
  },
  // for isMobile
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },

    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
    },

    methods: {
      onResize () {
        this.isMobile = window.innerWidth < 600
      },
    },
}
</script>
<style>
/*@import url(/css/reset.css);*/
/*@import url(/assets/css/fonts.css);*/
#app {
  /*background-image: url(/img/animate-logo-white.svg);*/
  background-position: center !important;
  background-attachment: fixed !important;
  background-repeat: no-repeat !important;
  background-size: auto 100vh !important;
  /*background-size: 70vh !important;*/
  background-size: cover !important;
  font-family: "EnigmaticUnicodeRegular" !important;
  /*transition: top 1s ease-out 0.5s;*/
}

/* Прокрутка по элементам (для мобильной версии)*/
.scroll-snap-type {
  scroll-snap-type: y proximity;
  scroll-padding-top: 55px;
  height: 100vh;
  overflow: scroll;
}
.scroll-snap-type-item {
  scroll-snap-align: start;
}

/* Анимация перехода между страницами */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s;
}

.fade-enter,
.fade-leave-to {/* .fade-leave-active до версии 2.1.8 */
opacity: 0;
}

.footer-link {
    font-size: .625rem !important;
    font-weight: 400;
    letter-spacing: .1666666667em !important;
    line-height: 1rem;
    text-transform: uppercase;
    /*color: #ff7100 !important;*/
    font-family: "EnigmaticUnicodeRegular" !important;
}
.in-text-link {
    /*color: #00b8d4;*/
    transition: 0.5s;
    text-decoration: none;
}
.in-text-link:hover {
    color: #ff7100;
}
</style>
